<template>
	<app-tabs tabsClass="has-background-link is-fullwidth" tabDetailClass="tab-detail">
		<app-tab name="Документы" tabClass="tab docs" :selected="true">
			<no-data-place-holder v-if="isEmpty"></no-data-place-holder>
			<custom-scroll v-else>				
				<search-result-isogd-sections :search-result="searchResult"></search-result-isogd-sections>				
			</custom-scroll>
		</app-tab>
		<app-tab name="Что строить?" tabClass="tab whats">
			<urban-terzone-regulation-list :project-schema="currentProject.schema"></urban-terzone-regulation-list>
		</app-tab>
	</app-tabs>
</template>
<script>
	import AppTabs from "@/components/common/Tabs";
	import AppTab from "@/components/common/Tab";	
	
	import UrbanTerzoneRegulationList from "./UrbanTerzoneRegulationList";
	import SearchResultIsogdSections from "./SearchResultIsogdSections";
	
	import { mapState } from 'vuex';
	export default {
		props: {
			searchResult: {
				type: Object,
				default: () => { }
			}
		},
		components: {
			AppTabs,
			AppTab,						
			UrbanTerzoneRegulationList,
			SearchResultIsogdSections
		},
		computed: {
			...mapState([
				'currentProject'				
			]),
			isEmpty() {				
				return this.searchResult == null || this.searchResult.isEmpty();
			}
		}
	}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
	@import '../../assets/sass/main.scss';

	.tab-padding {
		padding: 1rem 1.5rem;
	}

	.tab-detail {
		height: calc(100vh - 5.5em - #{$navbar-height});
	}

	.tab {
		background-repeat: no-repeat;
		background-position-x: center;
		background-position-y: 1.2rem;
	}

		.tab a {
			padding-top: 2.3rem !important;
		}

	.whats {
		background-image: url(../../assets/svg/whats.svg);
	}

		.whats.is-active {
			background-image: url(../../assets/svg/whats-active.svg);
		}

	.docs {
		background-image: url(../../assets/svg/docs.svg);
	}

		.docs.is-active {
			background-image: url(../../assets/svg/docs-active.svg);
		}
</style>
